import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navigation({ darkMode, setDarkMode }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navClass = darkMode 
    ? 'bg-gray-900 border-gray-700' 
    : 'bg-white border-gray-200';

  const linkClass = (path) => {
    const baseClass = 'px-4 py-2 rounded-lg transition-all duration-300 hover:scale-105 font-medium';
    const activeClass = darkMode 
      ? 'bg-blue-600 text-white shadow-lg' 
      : 'bg-blue-500 text-white shadow-lg';
    const inactiveClass = darkMode 
      ? 'text-gray-300 hover:bg-gray-800 hover:text-white' 
      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900';
    
    return `${baseClass} ${location.pathname === path ? activeClass : inactiveClass}`;
  };

  const mobileLinkClass = (path) => {
    const baseClass = 'block px-4 py-3 rounded-lg transition-all duration-300 font-medium';
    const activeClass = darkMode 
      ? 'bg-blue-600 text-white' 
      : 'bg-blue-500 text-white';
    const inactiveClass = darkMode 
      ? 'text-gray-300 hover:bg-gray-800' 
      : 'text-gray-600 hover:bg-gray-100';
    
    return `${baseClass} ${location.pathname === path ? activeClass : inactiveClass}`;
  };

  return (
    <nav className={`border-b sticky top-0 z-50 backdrop-blur-md bg-opacity-90 ${navClass}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* 🔥 로고 - 크기 대폭 증가 */}
          <Link to="/" className="flex items-center space-x-3 hover:scale-105 transition-transform duration-300">
            <div className="text-4xl">😺</div>
            <div className="font-black text-3xl bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              면접톡
            </div>
          </Link>

          {/* 데스크톱 메뉴 */}
          <div className="hidden md:flex items-center space-x-2">
            <Link to="/" className={linkClass('/')}>
              🏠 면접연습
            </Link>
            <Link to="/about" className={linkClass('/about')}>
              📖 서비스소개
            </Link>
            <Link to="/guide-success" className={linkClass('/guide-success')}>
              📚 면접성공가이드
            </Link>
            <a 
              href="https://jobangel.tistory.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="px-4 py-2 rounded-lg transition-all duration-300 hover:scale-105 font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white"
            >
              📝 취업천사블로그
            </a>
            <Link to="/guide" className={linkClass('/guide')}>
              💡 이용가이드
            </Link>
          </div>

          {/* 다크모드 토글 */}
          <div className="flex items-center space-x-4">
            <button
              onClick={() => setDarkMode(!darkMode)}
              className={`p-2 rounded-lg transition-all duration-300 hover:scale-110 ${
                darkMode 
                  ? 'bg-gray-800 text-yellow-400 hover:bg-gray-700' 
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
              aria-label="다크모드 토글"
            >
              {darkMode ? '🌞' : '🌙'}
            </button>

            {/* 모바일 메뉴 버튼 */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`md:hidden p-2 rounded-lg transition-all duration-300 ${
                darkMode 
                  ? 'text-gray-300 hover:bg-gray-800' 
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
              aria-label="메뉴 열기"
            >
              <div className="w-6 h-6 flex flex-col justify-center items-center">
                <div className={`h-0.5 w-6 bg-current transform transition-all duration-300 ${
                  isMenuOpen ? 'rotate-45 translate-y-1.5' : ''
                }`}></div>
                <div className={`h-0.5 w-6 bg-current transition-all duration-300 my-1 ${
                  isMenuOpen ? 'opacity-0' : ''
                }`}></div>
                <div className={`h-0.5 w-6 bg-current transform transition-all duration-300 ${
                  isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''
                }`}></div>
              </div>
            </button>
          </div>
        </div>

        {/* 모바일 메뉴 */}
        <div className={`md:hidden transition-all duration-300 overflow-hidden ${
          isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}>
          <div className="py-4 space-y-1 border-t border-opacity-20 overflow-y-auto max-h-80">
            <Link 
              to="/" 
              className={mobileLinkClass('/')}
              onClick={() => setIsMenuOpen(false)}
            >
              🏠 면접연습
            </Link>
            <Link 
              to="/about" 
              className={mobileLinkClass('/about')}
              onClick={() => setIsMenuOpen(false)}
            >
              📖 서비스소개
            </Link>
            <Link 
              to="/guide-success" 
              className={mobileLinkClass('/guide-success')}
              onClick={() => setIsMenuOpen(false)}
            >
              📚 면접성공가이드
            </Link>
            <a 
              href="https://jobangel.tistory.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block px-4 py-3 rounded-lg transition-all duration-300 font-medium text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"
              onClick={() => setIsMenuOpen(false)}
            >
              📝 취업천사블로그
            </a>
            <Link 
              to="/guide" 
              className={mobileLinkClass('/guide')}
              onClick={() => setIsMenuOpen(false)}
            >
              💡 이용가이드
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;